import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { constantvalues } from "../../../const";
import { environment } from "../../environments/environment.development";
import { DtoSubCategory, DtoSubCategoryMetric } from "../../../models/package-center.model";

@Injectable({
    providedIn: 'root'
})

export class SubCategoryService {
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl;
    }

    getSubCategory(sectorId: number, payload: any) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.CRUD_SUBCATEGORY}/${sectorId}`, {params: payload});
    }

    getMetricsForSubCategory(sectorId: number, payload: DtoSubCategory | any) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.GET_METRICS_FOR_SUBCATEGORY}/${sectorId}`, payload);
    }

    createSubCategory(subCategoryDetail: DtoSubCategoryMetric) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CRUD_SUBCATEGORY}`, subCategoryDetail);
    }

    updateSubCategory(subCategoryDetail: DtoSubCategoryMetric) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_SUBCATEGORY}`, subCategoryDetail);
    }

    deleteSubCategory(subCategoryId: number) {
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.CRUD_SUBCATEGORY}`, {
            params: {
                subCategoryId: subCategoryId
            }
        });
    }

    updateSubCategoryStatus(subCategoryId: number) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_SUBCATEGORY}/${subCategoryId}`, null);
    }
}